export enum FolderUrlName {
    AddedToPortfolio = 'added-to-portfolio',
    ExternalListings = 'external-listings',
    NotAssignedToFolder = 'not-assigned',
    RemovedListings = 'removed-listings',
}